import { Statements } from 'types/statements';
import http from 'utils/axios';

export const getStatements = async () => {
  const { data } = await http.get<Statements[]>(`/statements`);

  return data;
};
